<script setup lang="ts">
import { AvatarRoot } from "reka-ui";
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";
import { type AvatarVariants, avatarVariant } from ".";

const props = withDefaults(
	defineProps<{
		class?: HTMLAttributes["class"];
		size?: AvatarVariants["size"];
		shape?: AvatarVariants["shape"];
	}>(),
	{
		size: "sm",
		shape: "circle",
	},
);
</script>

<template>
	<AvatarRoot :class="twMerge(avatarVariant({ size, shape }), props.class)">
		<slot />
	</AvatarRoot>
</template>
